import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/useReduxHooks";
import { selectAuth, setAuth } from "features/authSlice";
import { history } from "utils/history";
import { SSEManager } from "../components/SSEManager";
import { AppRoutes } from "../types/enums";
import { useLogout } from "../hooks";
import { useLoginWithLinkMutation } from "../api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomToast } from "../components/ui/CustomToast";
import { CustomLoader } from "../components/ui/CustomLoader";

export const PrivateLayout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(selectAuth);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const logout = useLogout();
  const [loginWithLink] = useLoginWithLinkMutation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("login_link_token");
    const email = urlParams.get("email");

    if (token && email) {
      setIsLoading(true);
      loginWithLink({ email, token })
        .unwrap()
        .then((data) => {
          localStorage.setItem("success", "is login");
          dispatch(
            setAuth({
              accessToken: data.access_token,
              refreshToken: data.refresh_token,
            }),
          );

          toast.success(
            <CustomToast
              type="success"
              text="You’ve successfully logged in using a temporary access link."
              title="Welcome back!"
            />,
          );

          navigate(AppRoutes.CAMPAINGS, { replace: true });
        })
        .catch(() => {
          toast.error(
            <CustomToast
              type="error"
              text="The temporary login link is no longer valid. Request a new one to access the platform."
              title="This link has expired"
            />,
          );
          logout();
        });
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) return <CustomLoader />;

  if (!isLoggedIn) {
    return <Navigate to={AppRoutes.LOGIN} state={{ from: history.location }} />;
  }

  return (
    <>
      <SSEManager />
      <Outlet />
    </>
  );
};
